import React from 'react';
import styled from "styled-components";
import { Input, } from "codogo-react-widgets";
import { compose, withState, withHandlers, } from "recompose";

import Nav from "./nav";
import Font from "./font";

// -----------------------------------

const View = styled.div`
	width: 100%;
	min-height: 100%;
	display: inline-block;
`;

const MainWrapper = styled.div`
	background-color: #4B5F5F; 
	width: 100%;
	height: 100%;
	padding: 2em;
	display: inline-block;
`;

// -----------------------------------

const FontList = [
	"Arial",
	"Avenir Next",
	"Circular",
	"Montserrat",
	"Poppins",
	"Proxima Nova",
];

const enhance = compose(
	withState('sampleText', 'setSampleText', "Helvetica is a basic bitch"),
	withHandlers({ 
		onChangeText: props => e => props.setSampleText(e.target.value),
	}),
);

const MainView = enhance(({ sampleText, onChangeText, }) => 
	<div>
		<Input
			placeholder = "Try your own sentence..."
			onChange = { onChangeText }
		/>

		{
			FontList.map( (font, ) => {
				return <Font
					text = { sampleText }
					font = { font }
				/>
			})
		}
	</div>
)

// -----------------------------------

export default () => 
	<View>
		<Nav/>

		<MainWrapper>
			<MainView/>
		</MainWrapper>
	</View>;



// WEBPACK FOOTER //
// ./src/components/mainview.js